// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>16</span>&nbsp;&nbsp;But Israel would I feed with the finest wheat&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and with honey from the rock would I satisfy them.<br> </p> </div></div>";
// Exports
module.exports = code;